export default __webpack_public_path__ + "static/6656-eb8858c7e01180d5020d079e6515c153.jpg";